import React from "react";

/**
 * @component ArrowLeftBoxIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowLeftBoxIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowLeftBoxIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ArrowLeftBoxIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M8.92 15.59L6.33 13H16v-2H6.33l2.59-2.59L7.5 7l-5 5 5 5 1.42-1.41zM8 3v2h11v14H8v2h11a2 2 0 002-2V5c0-1.11-.89-2-2-2H8z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ArrowLeftBoxIcon.displayName = "ArrowLeftBoxIcon";
export default ArrowLeftBoxIcon;
